import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgScope = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "currentColor",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M7.5 6a4.5 4.5 0 1 1 9 0v12a4.5 4.5 0 1 1-9 0V6Z" })
});
export default SvgScope;
